import BaseService from "../base-service";
import { Category } from "./category.model";

export default class CategoriesService extends BaseService<Category> {
  get endpoint() {
    return "categories";
  }
}
